import React from 'react';
import useSubjectsContext from './context';
import RawHTML from '~/components/jsx-helpers/raw-html';
import './info-boxes.scss';
function AboutBlurb({ image, heading, text: description }) {
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "blurb" },
            React.createElement("div", null,
                React.createElement("img", { src: image.file, role: "presentation" }),
                React.createElement("h3", { className: "title" }, heading)),
            React.createElement(RawHTML, { Tag: "p", className: "text", html: description }))));
}
export function InfoBoxes({ infoBoxes }) {
    return (React.createElement("section", { className: "info-boxes" },
        React.createElement("div", { className: "content" }, infoBoxes.map((b, i) => (React.createElement(AboutBlurb, Object.assign({}, b, { key: i })))))));
}
export default function InfoBoxesUsingContext() {
    var _a;
    const { infoBoxes } = useSubjectsContext();
    const unwrappedData = (_a = infoBoxes[0]) === null || _a === void 0 ? void 0 : _a.value;
    return React.createElement(InfoBoxes, { infoBoxes: unwrappedData });
}
